import { lazyValue } from './lazy-value';
export class ApplicationContextInitializedError extends Error {
    constructor(initPoint) {
        super('ApplicationContext not initialized. query point: ' + initPointToString(initPoint));
    }
}
export const lazyAppContext = (initPoint) => {
    return lazyValue(() => new ApplicationContextInitializedError(initPoint));
};
function initPointToString(initPoint) {
    if (initPoint === undefined || initPoint === null)
        return 'unknown';
    if (typeof initPoint === 'string')
        return initPoint;
    if (typeof initPoint === 'function')
        return initPoint.name;
    try {
        return initPoint.toString();
    }
    catch {
        return 'unknown';
    }
}
//# sourceMappingURL=lazy-app-context.js.map